import { render, staticRenderFns } from "./AdminPageTitle.vue?vue&type=template&id=118fbc2a&scoped=true&"
import script from "./AdminPageTitle.vue?vue&type=script&lang=js&"
export * from "./AdminPageTitle.vue?vue&type=script&lang=js&"
import style0 from "./AdminPageTitle.vue?vue&type=style&index=0&id=118fbc2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118fbc2a",
  null
  
)

export default component.exports